// @flow

import type { AlertsState } from "./types";

export const initialState: AlertsState = {
  requestsInProgress: 0,
  list: [],
};

export default initialState;
